import React, { useState } from "react";
import "./QuestionCard.scss";
import { BadIcon, GoodIcon, OkIcon, VeryGoodIcon, WrapperIcon } from "../../../../assets/img/svg/icons/Icons.js";

function QuestionCard({ children, onSelectScore }) {
  const [selectedEmoji, setSelectedEmoji] = useState(null);

  const emojiData = [
    { label: "Bad", color: "#D30000", score: 25 },
    { label: "Ok", color: "#ED8000", score: 50 },
    { label: "Good", color: "#EDC700", score: 75 },
    { label: "Very Good", color: "#009D10", score: 100 },
  ];

  const toggleColor = (index, score) => {
    setSelectedEmoji(selectedEmoji === index ? null : index);
    onSelectScore(score, selectedEmoji === index);
  };

  return (
    <div className="question-card">
      <label className="question">{children && children}</label>
      <div className="emoji-review">
        {emojiData.map((emoji, index) => (
          <div
            key={index}
            className={`emoji ${selectedEmoji === index ? "selected" : ""}`}
            onClick={() => toggleColor(index, emoji.score)}
          >
            <WrapperIcon selectedEmoji={selectedEmoji} index={index} emoji={emoji}>
              <circle cx="22" cy="22" r="22" fillOpacity="0.81" />
              {emoji.label === "Bad" && (
                <BadIcon selectedEmoji={selectedEmoji} index={index} />
              )}
              {emoji.label === "Ok" && (
                <OkIcon selectedEmoji={selectedEmoji} index={index} />
              )}
              {emoji.label === "Good" && (
                <GoodIcon selectedEmoji={selectedEmoji} index={index} />
              )}
              {emoji.label === "Very Good" && (
                <VeryGoodIcon selectedEmoji={selectedEmoji} index={index} />
              )}
            </WrapperIcon>
            <label>{emoji.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuestionCard;
